import FollowPodcastPrompt, {
  FollowPodcastPromptProps,
} from './FollowPodcastPrompt';

export default FollowPodcastPrompt;
export type { FollowPodcastPromptProps };
